/**
 * Import des styles
 * ****************************************
 */
import "./sass/main.scss";

/**
 * Import des modules
 * ****************************************
 */
import RecipesFilters from "./ts/RecipesFilters";
import Menu from "./ts/Menu";
import VideoPopups from "./ts/VideoPopups";
import HomeSliders from "./ts/HomeSliders";
import TestimonialsSliders from "./ts/TestimonialsSliders";
import RelatedContentSliders from "./ts/RelatedContentSliders";
import MediaLibrary from "./ts/MediaLibrary";

/**
 * Initialisation des modules
 * ******************************
 */
window.onload = () => {
	/**
	 * Gestion des filtres de la page "recettes"
	 * ******************************
	 */
	RecipesFilters();

	/**
	 * Gestion des sous-menus
	 * ******************************
	 */
	Menu();

	/**
	 * Gestion des popups "video"
	 * ******************************
	 */
	VideoPopups();

	/**
	 * Gestion des sliders sur la "home"
	 * ******************************
	 */
	HomeSliders();

	/**
	 * Gestion des sliders "témoignages"
	 * ******************************
	 */
	TestimonialsSliders();

	/**
	 * Gestion des sliders "contenu connexe"
	 * ******************************
	 */
	RelatedContentSliders();

	/**
	 * Gestion de la médiathèque
	 * ******************************
	 */
	MediaLibrary();
};
